import * as React from 'react';
import type { SVGProps } from 'react';

const IconLinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" {...props}>
    <path
      d="M0 3.745h2.736v8.943H0V3.745Zm10.495.552c.544.298.99.75 1.341 1.355s.527 1.223.527 1.854v5.182H9.6V7.506c0-.14-.053-.298-.158-.473-.105-.176-.202-.29-.29-.342-.14-.088-.333-.132-.578-.132-.246 0-.438.035-.579.105l-1.13.553v5.47H4.102V3.746h2.762v.42c.544-.245 1.158-.359 1.841-.342.684.018 1.28.176 1.79.474ZM1.368.299c.386 0 .71.131.973.394s.395.588.395.974c0 .385-.132.714-.395.986a1.3 1.3 0 0 1-.973.408 1.3 1.3 0 0 1-.973-.408A1.367 1.367 0 0 1 0 1.667C0 1.28.132.957.395.693.658.43.982.3 1.368.3Z"
      fill="currentColor"
    />
  </svg>
);
export default IconLinkedIn;
